/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    createAmc : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('amcs', data.data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateAmc : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('amcs/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteAmc : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('amcs/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAmcs : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('amcs', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getAmc : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('amcs/' + data.id, {}).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    }
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/AmcModule.js